import React from 'react'
import './footer.css'
function Footer() {
  return (
    <div>
      <div className='contenedor-footer'>
        <h3>Contactame!</h3>
        <div className='contenedor-redes'>
        <a href="mailto:lucaslunaclaraso@gmail.com"> Correo Electrónico</a>
        <a href="wa.link/gbgytw">WhatsApp</a>
        <a href="https://www.linkedin.com/in/lucas-luna-claras%C3%B3-03a846203/">Linkedin</a>
        </div>
      </div>
    </div>
  )
}

export default Footer